import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "basePageWraper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "hero is-link" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hero-body" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "title has-text-left" }, " 회원가입 "),
    /*#__PURE__*/_createElementVNode("p", { class: "subtitle has-text-left" }, " 서비스 설명 ")
  ])
], -1)
const _hoisted_3 = { class: "box has-text-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("pre", null, "kck Doc Center 는 사내에서 외부로 배포하는 문서와 협력사\n에서 제공하는 문서를 정리 및 배포하기 위한 서비스 입니다.\n회원가입후 확인된 이메일주소를 통해 사용권한을 드릴 예정입니다. \n감사합니다.", -1)
const _hoisted_5 = { class: "mt-3 has-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.click_ok && _ctx.click_ok(...args))),
          class: "button is-info"
        }, "확인")
      ])
    ])
  ]))
}